var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.5H8.5M19 12H17M8.5 12H14M19 16.5H8.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.5C4.25 6.94772 4.69772 6.5 5.25 6.5V6.5C5.80228 6.5 6.25 6.94772 6.25 7.5V7.5C6.25 8.05228 5.80228 8.5 5.25 8.5V8.5C4.69772 8.5 4.25 8.05228 4.25 7.5V7.5Z",
    fill: "#292556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12C4.25 11.4477 4.69772 11 5.25 11V11C5.80228 11 6.25 11.4477 6.25 12V12C6.25 12.5523 5.80228 13 5.25 13V13C4.69772 13 4.25 12.5523 4.25 12V12Z",
    fill: "#292556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 16.5C4.25 15.9477 4.69772 15.5 5.25 15.5V15.5C5.80228 15.5 6.25 15.9477 6.25 16.5V16.5C6.25 17.0523 5.80228 17.5 5.25 17.5V17.5C4.69772 17.5 4.25 17.0523 4.25 16.5V16.5Z",
    fill: "#292556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.2d9ecdb173eaf35d7cb41fedea100dc2.svg";
export { ForwardRef as ReactComponent };